var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.6251C7.85834 10.6251 5.70834 8.47508 5.70834 5.83341C5.70834 3.19175 7.85834 1.04175 10.5 1.04175C13.1417 1.04175 15.2917 3.19175 15.2917 5.83341C15.2917 8.47508 13.1417 10.6251 10.5 10.6251ZM10.5 2.29175C8.55001 2.29175 6.95834 3.88341 6.95834 5.83341C6.95834 7.78341 8.55001 9.37508 10.5 9.37508C12.45 9.37508 14.0417 7.78341 14.0417 5.83341C14.0417 3.88341 12.45 2.29175 10.5 2.29175Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6585 18.9583C17.3168 18.9583 17.0335 18.675 17.0335 18.3333C17.0335 15.4583 14.1001 13.125 10.5001 13.125C6.90013 13.125 3.9668 15.4583 3.9668 18.3333C3.9668 18.675 3.68346 18.9583 3.3418 18.9583C3.00013 18.9583 2.7168 18.675 2.7168 18.3333C2.7168 14.775 6.20846 11.875 10.5001 11.875C14.7918 11.875 18.2835 14.775 18.2835 18.3333C18.2835 18.675 18.0001 18.9583 17.6585 18.9583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f582cde82801a885e7743e201b30cb36.svg";
export { ForwardRef as ReactComponent };